import * as TYPES from './constants';
import {
  requestBusinessPartnerIndustry,
  receiveBusinessPartnerIndustry,
  handleBusinessPartnerIndustryError,
} from './actions';

import {Services} from 'core';

import {API} from 'config/businesspartner.config';

const initialState = {
  data: null,
  request: null,
  error: null,
};

const services = new Services();
export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_BUSINESS_PARTNER_INDUSTRY:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_BUSINESS_PARTNER_INDUSTRY:
      return {
        ...state,
        data: action.payload,
        request: false,
        error: false,
      };
    case TYPES.BUSINESS_PARTNER_INDUSTRY_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    default:
      return state;
  }
};

export const fetchBusinessPartnerIndustry = () => (dispatch, getState) => {
  const {
    auth: {access: {token = null} = {}},
  } = getState();
  dispatch(requestBusinessPartnerIndustry());
  let endpoint = `${API.administration.industry}`;
  try {
    return services
      .fetchRecords(endpoint, token)
      .then(res => {
        dispatch(receiveBusinessPartnerIndustry(res));
      })
      .catch(err => console.log(err));
  } catch (err) {
    console.log(err);
    dispatch(handleBusinessPartnerIndustryError(err));
  }
};
